var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"mode":"horizontal","background-color":"#333","text-color":"#fff","active-text-color":"#fff"},on:{"select":_vm.handleSelect}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }